import type { JSX } from 'preact';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  id?: string;
}

export function Checkbox({ checked, onChange, label, id }: CheckboxProps) {
  const handleChange = (e: JSX.TargetedEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.checked);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        id={id}
      />
      {label && (
        <label
          for={id}
          style={{ fontSize: '0.84rem', color: 'var(--text-secondary)', cursor: 'pointer' }}
        >
          {label}
        </label>
      )}
    </div>
  );
}
